import { CancellationPolicyViewModel } from 'models';

import { PriceDetailsFragment, PropertyCancellationPolicyType, RatePlanFragment } from '__generated__/api';

import RatePlan = RatePlanFragment.Fragment;
import CancellationPolicy = PriceDetailsFragment.CancellationPolicy;

export const adaptCancellationPolicy = (ratePlan: RatePlan): CancellationPolicyViewModel | null => {
  const cancellationPolicy =
    ratePlan && ratePlan.priceDetails && ratePlan.priceDetails.length > 0 ? ratePlan.priceDetails[0].cancellationPolicy : null;

  if (!cancellationPolicy) {
    return null;
  }

  const freeCancel = cancellationPolicy.type === PropertyCancellationPolicyType.REFUNDABLE_WITH_NO_PENALTY;
  const localizedCancellationDateTime = adaptCancellationDate(cancellationPolicy);
  const nonRefundable = cancellationPolicy.type === PropertyCancellationPolicyType.NON_REFUNDABLE;

  return {
    freeCancel,
    policyText: cancellationPolicy.text,
    localizedCancellationDateTime,
    nonRefundable,
  };
};

export const adaptCancellationDate = (cancellationPolicy: CancellationPolicy) => {
  if (cancellationPolicy.cancellationWindow?.fullDateFormat != null) {
    return cancellationPolicy.cancellationWindow?.fullDateFormat;
  }

  return null;
};
